import { Click }                 from '../../../click/click.class'
import { BET_VALUES }            from '../../../../constants/bet-values/bet-values.constant'
import { BetInterfaceButton }    from './betInterface.button.class'
import { BET_INTERFACE_BUTTONS } from '../../../../constants/betInterfaceButton/bet-interface-buttons.constant'

/**
 * @file Defines the {@link BetPlus} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** 
  * Class for handling plus button in bet interface
  * @extends BetInterfaceButton
  */
 export class BetPlus extends BetInterfaceButton {

    /**
     * Initialise plus button content
     */
    constructor() {
        super(BET_INTERFACE_BUTTONS.plus) //Call parent constructor
    }

    /** Adds click handler to plus button */
    add() {

        let plus = document.getElementById(BET_INTERFACE_BUTTONS.plus.id) //Retrieve plus button node
        new Click(plus, this.click, this)                                 //Add click handler
        this.added = true                                                 //Update click handler flag

    }

    /**
     * Click handler for increasing bet value
     * @param {object} this_ - Reference to class's scope
     */
    click(this_) {
 
        BET_VALUES.increase() //Increase bet value
        super.click()         //Call super click
 
    }

 }